import React from 'react';
import { CardInvalide } from '../Cards';

const PageMdpOublieKo = () => (
    <CardInvalide Lien="/MotdepasseOublie">
        <p>Un problème est survenu lors de la réinitialisation du mot de passe.</p>
        <p>Ce lien n&apos;est plus valide.</p>
        <p>Merci de recommencer la procédure.</p>
    </CardInvalide>
);

export default PageMdpOublieKo;



// WEBPACK FOOTER //
// ./src/components/Adherent/MdpOublie/PageMdpOublieKo.js